import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleRecommend() {
  const featuredArticles = articles.slice(0, 4);

  return (
    <section className="py-12 md:py-16 bg-background-100">
      <div className="site-container">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              观影指南
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新影视资讯与深度影评</p>
          </div>
          <Link
            to="/articles"
            className="flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap"
          >
            全部文章
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.cover}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 leading-snug line-clamp-2 font-heading group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
                  {article.summary}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}